import { render, staticRenderFns } from "./ArticleTile.vue?vue&type=template&id=99e8bf78&scoped=true"
import script from "./ArticleTile.vue?vue&type=script&lang=js"
export * from "./ArticleTile.vue?vue&type=script&lang=js"
import style0 from "./ArticleTile.vue?vue&type=style&index=0&id=99e8bf78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e8bf78",
  null
  
)

export default component.exports